import { Catalogue, Delivery } from '../types';
import { DeliveryOptions } from '../types/application/delivery-options';
import { getTitleListFromSolutions } from './get-title-list-from-solutions';
import { getTotalDevicesFromSolution } from './get-total-devices-from-solution';

export function splitAddressByDevice(
  delivery: Delivery,
  catalogue: Catalogue,
  onChangeDelivery: (deliveryOption: DeliveryOptions, solutionId: string) => void,
) {
  return delivery.solutions.map((solution) => {
    const device = getTitleListFromSolutions([solution], catalogue);

    return {
      addressLines: [
        delivery.address?.street || '',
        delivery.address?.city || '',
        delivery.address?.province || '',
        delivery.address?.postalCode || '',
      ],
      deliveryOptions: device?.[0]?.deliveryOptions,
      deliveryOption: solution.deliveryOption,
      onChangeDeliveryOption: (deliveryOption: DeliveryOptions) => {
        solution.deliveryOption = deliveryOption;
        onChangeDelivery(deliveryOption, solution.productId);
      },
      productId: solution.productId,
      addressId: delivery.id,
      productDetails: {
        devices: device?.[0]?.title,
        image: device?.[0]?.image,
        quantity: getTotalDevicesFromSolution([solution], catalogue),
      },
      secondaryAcquiringChannel: device?.[0]?.secondaryAcquiringChannel,
    };
  });
}
